var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "footer_linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1207",
    d: "M3.87198 10.1727H7.35997V21.3987H3.87198V10.1727ZM5.61597 4.59474C6.01618 4.59355 6.40775 4.71115 6.74107 4.93265C7.0744 5.15415 7.33449 5.46959 7.48842 5.83901C7.64235 6.20844 7.6832 6.61523 7.60577 7.00788C7.52835 7.40053 7.33615 7.76138 7.05351 8.04472C6.77087 8.32807 6.41049 8.52116 6.01804 8.59956C5.62558 8.67795 5.2187 8.63812 4.84889 8.4851C4.47909 8.33209 4.163 8.07277 3.94067 7.73999C3.71835 7.40721 3.59978 7.01594 3.59998 6.61573C3.60024 6.08067 3.81256 5.56754 4.19043 5.18873C4.5683 4.80992 5.08091 4.59632 5.61597 4.59474Z",
    fill: "#82858B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1208",
    d: "M9.54492 10.1736H12.8849V11.7066H12.9299C13.2644 11.134 13.748 10.6629 14.3291 10.3434C14.9103 10.0239 15.5672 9.86815 16.2299 9.89264C19.7529 9.89264 20.4039 12.2166 20.4039 15.2396V21.3966H16.9269V15.9366C16.9269 14.6366 16.8999 12.9616 15.1169 12.9616C13.3039 12.9616 13.0279 14.3766 13.0279 15.8406V21.3936H9.54892L9.54492 10.1736Z",
    fill: "#82858B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e50c1908a9949de80370f6eba53708dc.svg";
export { ForwardRef as ReactComponent };